const sidebar = {
  groupCore: "Core",
  groupTools: "Tools",
  groupSystem: "System",
  filterMe: "Me",
  filterTeam: "Team",
  filterHidden: "Hidden",
  filterFavorites: "Favorites",
  viewList: "List",
  viewGrid: "Grid",
  viewCompact: "Compact",
  viewFolders: "Folders",
  viewFlat: "Flat",
  editMode: "Customize",
  doneEditing: "Done",
  autoSort: "Sort by usage",
  resetOrder: "Reset layout",
  resetConfirm: "Reset all customizations?",
  hide: "Hide",
  show: "Show",
  openNewTab: "Open in new tab",
  addFav: "Add to favorites",
  removeFav: "Remove from favorites",
  moveToFolder: "Move to folder...",
  newFolder: "New folder...",
  removeFromFolder: "Remove from folder",
  folderName: "Folder name",
  addNote: "Add note",
  editNote: "Edit note",
  hiddenCount: "hidden items",
  itemEdit: "Edit Tab",
  customLabel: "Custom Label",
  language: "Display Language",
  iconPosition: "Icon Position",
  changeIcon: "Change Icon",
  resetItem: "Reset Tab",
  langHe: "עברית",
  langEn: "English",
  langRu: "Русский",
  langCustom: "Custom",
  posStart: "Start",
  posEnd: "End",
  posAbove: "Above",
  addSection: "Add Section",
  newSectionName: "Section name...",
  deleteSection: "Delete section",
  appFolders: "App Folders",
  allApps: "All Apps",
  newAppFolder: "New folder",
  appFolderNamePlaceholder: "Folder name...",
  createFirstFolder: "Create your first folder",
  addToFolders: "Add to folders",
  inNFolders: "In {count} folders",
  manageFolders: "Manage folders",
  navItemsSection: "Navigation Items",
  deleteFolderConfirm: 'Delete folder "{name}"?',
} as const;
export default sidebar;
